import { FileToUpload } from './filetoupload';
import { HrEmpDocuments } from './hrEmpDocuments';
import { ProfileVerificationStatus } from './ProfileVerificationStatus';

export class HrEmployeePassportVisaInfo {
  passportDtls: HrEmpDocuments[];
  VisaDtls: HrEmpDocuments[];
  profileVerification: ProfileVerificationStatus = new ProfileVerificationStatus();
}
